// Snackbar variant constants
export const SNACKBAR_VARIANTS = {
  error: 'error',
  success: 'success',
  warning: 'warning',
  info: 'info',
};
